import React from 'react';

import Link from '@swf/components/Link/Link';
import { RoutingKey } from '@swf/core/enums';
import { ClubRoute } from '@swf/core/types/Poker';
import type { HgClubInfo } from '@swf/generated/types/api/v0/SwHomeGames';

import styles from './SidebarNav.scss';

interface Props {
  club: HgClubInfo;
}

const SidebarNavClubItem = ({ club: { clubName, clubId } }: Props) => (
  <Link route={RoutingKey.HomeGamesClubs} values={{ clubId, section: ClubRoute.Lobby }}>
    <div className={styles.clubName} title={clubName}>
      {clubName}
    </div>
  </Link>
);

export default SidebarNavClubItem;
